import faker from 'vue-faker'
import Vue from 'vue'

Vue.use(faker)
